import React, { useState, useEffect } from "react";
import { db } from "../../firebase/config";

function timeAgo(ts) {
  if (!ts) return "";
  const date = ts.toDate ? ts.toDate() : new Date(ts);
  const secs = Math.floor((Date.now() - date) / 1000);
  if (secs < 60)    return "just now";
  if (secs < 3600)  return `${Math.floor(secs / 60)}m ago`;
  if (secs < 86400) return `${Math.floor(secs / 3600)}h ago`;
  return `${Math.floor(secs / 86400)}d ago`;
}

const fmt = (n) => `MK ${Number(n).toLocaleString()}`;

export default function NotificationsSection() {
  const [items,   setItems]   = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let orders      = [];
    let users       = [];
    let withdrawals = [];

    const merge = () => {
      const combined = [...orders, ...users, ...withdrawals].sort((a, b) => {
        const ta = a.createdAt?.toDate ? a.createdAt.toDate() : new Date(a.createdAt || 0);
        const tb = b.createdAt?.toDate ? b.createdAt.toDate() : new Date(b.createdAt || 0);
        return tb - ta;
      });
      setItems(combined);
      setLoading(false);
    };

    const unsubOrders = db.collection("orders")
      .orderBy("createdAt", "desc")
      .limit(40)
      .onSnapshot((snap) => {
        orders = snap.docs.map((d) => ({ id: d.id, _type: "order", ...d.data() }));
        merge();
      });

    const unsubUsers = db.collection("users")
      .orderBy("createdAt", "desc")
      .limit(40)
      .onSnapshot((snap) => {
        users = snap.docs.map((d) => ({ id: d.id, _type: "user", ...d.data() }));
        merge();
      });

    const unsubWithdrawals = db.collection("referral_withdrawals")
      .orderBy("createdAt", "desc")
      .limit(40)
      .onSnapshot((snap) => {
        withdrawals = snap.docs.map((d) => ({ id: d.id, _type: "withdrawal", ...d.data() }));
        merge();
      });

    return () => { unsubOrders(); unsubUsers(); unsubWithdrawals(); };
  }, []);

  if (loading) return <p className="dash-empty">Loading notifications…</p>;
  if (!items.length) return <p className="dash-empty">No notifications yet.</p>;

  return (
    <div>
      <div className="dash-main__header">
        <h2 className="dash-main__title">Notifications</h2>
        <span className="notif-count-label">{items.length} recent</span>
      </div>

      <div className="notif-feed">
        {items.map((item) =>
          item._type === "withdrawal" ? (
            <div key={item.id} className="notif-item">
              <div className="notif-item__icon notif-item__icon--order">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="2" y="6" width="20" height="14" rx="2"/>
                  <path d="M2 10h20"/>
                </svg>
              </div>
              <div className="notif-item__body">
                <p className="notif-item__title">Payout Request</p>
                <p className="notif-item__sub">
                  {item.referralCode || "—"} · {item.amount ? fmt(item.amount) : ""}
                </p>
                <p className="notif-item__meta">{item.operator || ""} · {item.phone || ""}</p>
              </div>
              <span className="notif-item__time">{timeAgo(item.createdAt)}</span>
            </div>
          ) : item._type === "order" ? (
            <div key={item.id} className="notif-item">
              <div className="notif-item__icon notif-item__icon--order">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>
                  <line x1="3" y1="6" x2="21" y2="6"/>
                  <path d="M16 10a4 4 0 01-8 0"/>
                </svg>
              </div>
              <div className="notif-item__body">
                <p className="notif-item__title">New Order</p>
                <p className="notif-item__sub">
                  {item.customerName || "—"} · {item.total ? fmt(item.total) : ""}
                </p>
                <p className="notif-item__meta">
                  {item.deliverySummary || ""} · {item.paymentOperator || ""}
                </p>
              </div>
              <span className="notif-item__time">{timeAgo(item.createdAt)}</span>
            </div>
          ) : (
            <div key={item.id} className="notif-item">
              <div className="notif-item__icon notif-item__icon--user">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="8" r="4"/>
                  <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/>
                </svg>
              </div>
              <div className="notif-item__body">
                <p className="notif-item__title">New Sign-up</p>
                <p className="notif-item__sub">
                  {item.firstName || item.displayName || "Customer"} {item.lastName || ""}
                </p>
                <p className="notif-item__meta">{item.email || item.phone || ""}</p>
              </div>
              <span className="notif-item__time">{timeAgo(item.createdAt)}</span>
            </div>
          )
        )}
      </div>
    </div>
  );
}
